import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@pages/profile';

/** Profil-Route (/profile) — zeigt Clerk-Nutzerdaten und ermöglicht deren Bearbeitung. */
export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfilePage,
});
